import { ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';
import {
  WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ANTI_EXPLOIT,
  WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ANTI_TAMPERING,
  WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_DYNAMIC_THREAT_DEFENSE,
  WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_EXCLUSIONS,
  WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS,
  WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND,
  WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_EXECUTE,
  WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_SECURITY_SERVERS,
  WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_SETTINGS,
  WEB_COMPONENT_POLICY_PANEL_APPLICATION_CONTROL_GENERAL,
  WEB_COMPONENT_POLICY_PANEL_BLOCKLIST_RULES_GENERAL,
  WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_DATA_PROTECTION,
  WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_NETWORK_MONITOR,
  WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_TRAFFIC,
  WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_WEB,
  WEB_COMPONENT_POLICY_PANEL_DEVICE_CONTROL_EXCLUSIONS,
  WEB_COMPONENT_POLICY_PANEL_DEVICE_CONTROL_RULES,
  WEB_COMPONENT_POLICY_PANEL_EDR_SENSOR_GENERAL,
  WEB_COMPONENT_POLICY_PANEL_ENCRYPTION_GENERAL,
  WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE,
  WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTISPAM,
  WEB_COMPONENT_POLICY_PANEL_EXCHANGE_CONTENT_CONTROL,
  WEB_COMPONENT_POLICY_PANEL_EXCHANGE_PROTECTION_GENERAL,
  WEB_COMPONENT_POLICY_PANEL_FIREWALL_ADVANCED,
  WEB_COMPONENT_POLICY_PANEL_FIREWALL_NETWORK,
  WEB_COMPONENT_POLICY_PANEL_FIREWALL_SETTINGS,
  WEB_COMPONENT_POLICY_PANEL_GENERAL_ADVANCED,
  WEB_COMPONENT_POLICY_PANEL_GENERAL_COMMUNICATION,
  WEB_COMPONENT_POLICY_PANEL_GENERAL_DETAILS,
  WEB_COMPONENT_POLICY_PANEL_GENERAL_INHERITANCE,
  WEB_COMPONENT_POLICY_PANEL_GENERAL_NOTIFICATIONS,
  WEB_COMPONENT_POLICY_PANEL_GENERAL_SECURITY_TELEMETRY,
  WEB_COMPONENT_POLICY_PANEL_GENERAL_UPDATE,
  WEB_COMPONENT_POLICY_PANEL_INDICATORS_OF_RISK_GENERAL,
  WEB_COMPONENT_POLICY_PANEL_INTEGRITY_MONITOR_REAL_TIME,
  WEB_COMPONENT_POLICY_PANEL_LIVE_SEARCH,
  WEB_COMPONENT_POLICY_PANEL_NSX,
  WEB_COMPONENT_POLICY_PANEL_PATCH_MANAGEMENT_GENERAL,
  WEB_COMPONENT_POLICY_PANEL_RELAY_COMMUNICATION,
  WEB_COMPONENT_POLICY_PANEL_RELAY_UPDATE,
  WEB_COMPONENT_POLICY_PANEL_SANDBOX_ENDPOINT_SENSOR,
  WEB_COMPONENT_POLICY_PANEL_SANDBOX_ICAP_SENSOR,
  WEB_COMPONENT_POLICY_PANEL_SANDBOX_MANAGER,
  WEB_COMPONENT_POLICY_PANEL_SANDBOX_NETWORK_SENSOR,
  WEB_COMPONENT_POLICY_PANEL_STORAGE_PROTECTION_EXCLUSIONS,
  WEB_COMPONENT_POLICY_PANEL_STORAGE_PROTECTION_ICAP,
} from '../../../../webcomponents.constants';
import { PolicyPanelManager } from '../PolicyPanelManager';
import {
  getGeneralAdvancedSearchableKeywords,
  getGeneralCommunicationSearchableKeywords,
  getGeneralDetailsSearchableKeywords,
  getGeneralInheritanceRulesSearchableKeywords,
  getGeneralNotificationsSearchableKeywords,
  getGeneralSecurityTelemetrySearchableKeywords,
  getGeneralUpdateSearchableKeywordsSearchableKeywords,
} from './uiSettings/general/general.values';
import { getIndicatorsOfRiskSearchableKeywords } from './uiSettings/indicatorsOfRisk/indicators-of-risk.values';
import {
  getRelayCommunicationSearchableKeywords,
  getRelayUpdateSearchableKeywords,
} from './uiSettings/relay/relay.values';
import {
  getAntimalwareAntiExploitSearchableKeywords,
  getAntimalwareAntiTamperingSearchableKeywords,
  getAntimalwareDynamicThreatDefenseSearchableKeywords,
  getAntimalwareExclusionsSearchableKeywords,
  getAntimalwareOnAccessSearchableKeywords,
  getAntimalwareOnDemandSearchableKeywords,
  getAntimalwareOnExecuteSearchableKeywords,
  getAntimalwareSecurityServersSearchableKeywords,
  getAntimalwareSettingsSearchableKeywords,
} from './uiSettings/antimalware/antimalware.values';
import {
  getSandboxEndpointSensorSearchableKeywords,
  getSandboxIcapSensorSearchableKeywords,
  getSandboxManagerSearchableKeywords,
  getSandboxNetworkSensorSearchableKeywords,
} from './uiSettings/sandbox/sandbox.values';
import {
  getFirewallAdvancedSearchableKeywords,
  getFirewallNetworkSearchableKeywords,
  getFirewallSettingsSearchableKeywords,
} from './uiSettings/firewall/firewall.values';
import {
  getContentControlDataProtectionSearchableKeywords,
  getContentControlNetworkMonitorSearchableKeywords,
  getContentControlTrafficSearchableKeywords,
  getContentControlWebSearchableKeywords,
} from './uiSettings/contentControl/content-control.values';
import { getPatchManagementSearchableKeywords } from './uiSettings/patchManagement/patch-management.values';
import { getApplicationControlSearchableKeywords } from './uiSettings/applicationControl/application-control.values';
import {
  getDeviceControlExclusionsSearchableKeywords,
  getDeviceControlRulesSearchableKeywords,
} from './uiSettings/deviceControl/device-control.values';
import { getIntegrityMonitorRealTimeSearchableKeywords } from './uiSettings/integrityMonitor/integrity-monitor.values';
import {
  getExchangeAntimalwareSearchableKeywords,
  getExchangeAntispamSearchableKeywords,
  getExchangeContentControlSearchableKeywords,
  getExchangeProtectionGeneralSearchableKeywords,
} from './uiSettings/exchange/exchange-protection.values';
import { getEncryptionSearchKeywords } from './uiSettings/encryption/encryption.values';
import { getEdrSensorGeneralSearchableKeywords } from './uiSettings/edrSensor/edr-sensor.values';
import {
  getStorageExclusionsSearchableKeywords,
  getStorageIcapSearchableKeywords,
} from './uiSettings/storageProtection/storage-protection.values';
import { getLiveSearchSearchableKeywords } from './uiSettings/liveSearch/live-search.values';
import { getNsxSearchableKeywords } from './uiSettings/nsx/nsx.values';
import { getBlocklistRulesSearchableKeywords } from './uiSettings/blocklistRules/blocklist-rules.values';

export interface SectionConfig {
  uiElementName: string;
  guard: () => boolean;
  searchableKeywords: Function;
}

export function getModulesGuards() {
  const policyManager = PolicyPanelManager.getInstance();
  return {
    [ModuleId.POLICY_SETTINGS]: () => true,
    [ModuleId.GENERAL]: () => true,
    [ModuleId.RELAY]: () => true,
    [ModuleId.ANTIMALWARE]: () => true,
    [ModuleId.SANDBOX]: () => {
      return (
        policyManager.isSandboxEndpointSensorSectionAvailable() ||
        policyManager.isSandboxNetworkSensorSectionAvailable() ||
        policyManager.isSandboxIcapSensorSectionAvailable() ||
        policyManager.isSandboxManagerSectionAvailable()
      );
    },
    [ModuleId.FIREWALL]: policyManager.isFirewallModuleAvailable,
    [ModuleId.CONTENT_CONTROL]: () => true,
    [ModuleId.PATCH_MANAGEMENT]: policyManager.isPatchManagementModuleAvailable,
    [ModuleId.APPLICATION_CONTROL]: policyManager.isApplicationControlModuleAvailable,
    [ModuleId.DEVICE_CONTROL]: policyManager.isDeviceControlModuleAvailable,
    [ModuleId.INTEGRITY_MONITOR]: policyManager.isIntegrityMonitorModuleAvailable,
    [ModuleId.EXCHANGE_PROTECTION]: policyManager.isExchangeModuleAvailable,
    [ModuleId.ENCRYPTION]: policyManager.isEncryptionModuleAvailable,
    [ModuleId.EDR_SENSOR]: policyManager.isEdrSensorModuleAvailable,
    [ModuleId.STORAGE_PROTECTION]: policyManager.isStorageProtectionModuleAvailable,
    [ModuleId.INDICATORS_OF_RISK]: policyManager.isIndicatorsOfRiskModuleAvailable,
    [ModuleId.BLOCKLIST_RULES]: policyManager.isBlocklistModuleAvailable,
    [ModuleId.LIVE_SEARCH]: policyManager.isLiveSearchModuleAvailable,
    [ModuleId.NSX]: policyManager.isNsxModuleAvailable,
  };
}

export function getTreeConfig() {
  const policyManager = PolicyPanelManager.getInstance();
  return {
    [ModuleId.POLICY_SETTINGS]: {
      [SectionId.DETAILS]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_GENERAL_DETAILS,
        guard: () => true,
        searchableKeywords: getGeneralDetailsSearchableKeywords,
      },
      [SectionId.GENERAL_INHERITANCE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_GENERAL_INHERITANCE,
        guard: () => true,
        searchableKeywords: getGeneralInheritanceRulesSearchableKeywords,
      },
    },
    [ModuleId.GENERAL]: {
      [SectionId.GENERAL_NOTIFICATIONS]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_GENERAL_NOTIFICATIONS,
        guard: policyManager.isGeneralNotificationsAvailable,
        searchableKeywords: getGeneralNotificationsSearchableKeywords,
      },
      [SectionId.SETTINGS]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_GENERAL_ADVANCED,
        guard: () => true,
        searchableKeywords: getGeneralAdvancedSearchableKeywords,
      },
      [SectionId.COMMUNICATION]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_GENERAL_COMMUNICATION,
        guard: () => true,
        searchableKeywords: getGeneralCommunicationSearchableKeywords,
      },
      [SectionId.UPDATE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_GENERAL_UPDATE,
        guard: () => true,
        searchableKeywords: getGeneralUpdateSearchableKeywordsSearchableKeywords,
      },
      [SectionId.SECURITY_TELEMETRY]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_GENERAL_SECURITY_TELEMETRY,
        guard: policyManager.isGeneralSecurityTelemetryAvailable,
        searchableKeywords: getGeneralSecurityTelemetrySearchableKeywords,
      },
    },
    [ModuleId.RELAY]: {
      [SectionId.COMMUNICATION]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_RELAY_COMMUNICATION,
        guard: () => true,
        searchableKeywords: getRelayCommunicationSearchableKeywords,
      },
      [SectionId.UPDATE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_RELAY_UPDATE,
        guard: () => true,
        searchableKeywords: getRelayUpdateSearchableKeywords,
      },
    },
    [ModuleId.ANTIMALWARE]: {
      [SectionId.ANTIMALWARE_ON_ACCESS]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS,
        guard: policyManager.isAntimalwareOnAccessSectionAvailable,
        searchableKeywords: getAntimalwareOnAccessSearchableKeywords,
      },
      [SectionId.ANTIMALWARE_ON_EXECUTE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_EXECUTE,
        guard: () => true,
        searchableKeywords: getAntimalwareOnExecuteSearchableKeywords,
      },
      [SectionId.ANTIMALWARE_ON_DEMAND]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND,
        guard: policyManager.isAntimalwareOnDemandSectionAvailable,
        searchableKeywords: getAntimalwareOnDemandSearchableKeywords,
      },
      [SectionId.ANTIMALWARE_ANTI_TAMPERING]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ANTI_TAMPERING,
        guard: policyManager.isAntimalwareAntiTamperingSectionAvailable,
        searchableKeywords: getAntimalwareAntiTamperingSearchableKeywords,
      },
      [SectionId.ANTIMALWARE_DYNAMIC_THREAT_DEFENSE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_DYNAMIC_THREAT_DEFENSE,
        guard: policyManager.isAntimalwareDynamicThreatDefenseSectionAvailable,
        searchableKeywords: getAntimalwareDynamicThreatDefenseSearchableKeywords,
      },
      [SectionId.ANTIMALWARE_ANTI_EXPLOIT]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ANTI_EXPLOIT,
        guard: policyManager.isAntimalwareAntiExploitSectionAvailable,
        searchableKeywords: getAntimalwareAntiExploitSearchableKeywords,
      },
      [SectionId.ANTIMALWARE_SECURITY_SERVERS]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_SECURITY_SERVERS,
        guard: policyManager.isAntimalwareSecurityServersSectionAvailable,
        searchableKeywords: getAntimalwareSecurityServersSearchableKeywords,
      },
      [SectionId.SETTINGS]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_SETTINGS,
        guard: policyManager.isAntimalwareSettingsSectionAvailable,
        searchableKeywords: getAntimalwareSettingsSearchableKeywords,
      },
      [SectionId.EXCLUSIONS]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_EXCLUSIONS,
        guard: () => true,
        searchableKeywords: getAntimalwareExclusionsSearchableKeywords,
      },
    },
    [ModuleId.SANDBOX]: {
      [SectionId.ENDPOINT_SENSOR]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_SANDBOX_ENDPOINT_SENSOR,
        guard: policyManager.isSandboxEndpointSensorSectionAvailable,
        searchableKeywords: getSandboxEndpointSensorSearchableKeywords,
      },
      [SectionId.NETWORK_SENSOR]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_SANDBOX_NETWORK_SENSOR,
        guard: policyManager.isSandboxNetworkSensorSectionAvailable,
        searchableKeywords: getSandboxNetworkSensorSearchableKeywords,
      },
      [SectionId.ICAP_SENSOR]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_SANDBOX_ICAP_SENSOR,
        guard: policyManager.isSandboxIcapSensorSectionAvailable,
        searchableKeywords: getSandboxIcapSensorSearchableKeywords,
      },
      [SectionId.SANDBOX_MANAGER]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_SANDBOX_MANAGER,
        guard: policyManager.isSandboxManagerSectionAvailable,
        searchableKeywords: getSandboxManagerSearchableKeywords,
      },
    },
    [ModuleId.FIREWALL]: {
      [SectionId.SETTINGS]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_FIREWALL_SETTINGS,
        guard: policyManager.isFirewallModuleAvailable,
        searchableKeywords: getFirewallSettingsSearchableKeywords,
      },
      [SectionId.FIREWALL_NETWORK]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_FIREWALL_NETWORK,
        guard: policyManager.isFirewallModuleAvailable,
        searchableKeywords: getFirewallNetworkSearchableKeywords,
      },
      [SectionId.FIREWALL_ADVANCED]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_FIREWALL_ADVANCED,
        guard: policyManager.isFirewallModuleAvailable,
        searchableKeywords: getFirewallAdvancedSearchableKeywords,
      },
    },
    [ModuleId.CONTENT_CONTROL]: {
      [SectionId.CONTENT_CONTROL_TRAFFIC]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_TRAFFIC,
        guard: () => true,
        searchableKeywords: getContentControlTrafficSearchableKeywords,
      },
      [SectionId.CONTENT_CONTROL_WEB]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_WEB,
        guard: policyManager.isContentControlWebSectionAvailable,
        searchableKeywords: getContentControlWebSearchableKeywords,
      },
      [SectionId.CONTENT_CONTROL_DATA_PROTECTION]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_DATA_PROTECTION,
        guard: () => true,
        searchableKeywords: getContentControlDataProtectionSearchableKeywords,
      },
      [SectionId.CONTENT_CONTROL_NETWORK_MONITOR]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_NETWORK_MONITOR,
        guard: policyManager.isContentControlNetworkSectionAvailable,
        searchableKeywords: getContentControlNetworkMonitorSearchableKeywords,
      },
    },
    [ModuleId.PATCH_MANAGEMENT]: {
      [SectionId.NONE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_PATCH_MANAGEMENT_GENERAL,
        guard: policyManager.isPatchManagementModuleAvailable,
        searchableKeywords: getPatchManagementSearchableKeywords,
      },
    },
    [ModuleId.APPLICATION_CONTROL]: {
      [SectionId.NONE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_APPLICATION_CONTROL_GENERAL,
        guard: policyManager.isApplicationControlModuleAvailable,
        searchableKeywords: getApplicationControlSearchableKeywords,
      },
    },
    [ModuleId.DEVICE_CONTROL]: {
      [SectionId.RULES]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_DEVICE_CONTROL_RULES,
        guard: policyManager.isDeviceControlModuleAvailable,
        searchableKeywords: getDeviceControlRulesSearchableKeywords,
      },
      [SectionId.EXCLUSIONS]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_DEVICE_CONTROL_EXCLUSIONS,
        guard: policyManager.isDeviceControlModuleAvailable,
        searchableKeywords: getDeviceControlExclusionsSearchableKeywords,
      },
    },
    [ModuleId.INTEGRITY_MONITOR]: {
      [SectionId.INTEGRITY_MONITOR_REAL_TIME]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_INTEGRITY_MONITOR_REAL_TIME,
        guard: policyManager.isIntegrityMonitorModuleAvailable,
        searchableKeywords: getIntegrityMonitorRealTimeSearchableKeywords,
      },
    },
    [ModuleId.EXCHANGE_PROTECTION]: {
      [SectionId.GENERAL]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_EXCHANGE_PROTECTION_GENERAL,
        guard: policyManager.isExchangeModuleAvailable,
        searchableKeywords: getExchangeProtectionGeneralSearchableKeywords,
      },
      [SectionId.EXCHANGE_ANTIMALWARE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE,
        guard: policyManager.isExchangeModuleAvailable,
        searchableKeywords: getExchangeAntimalwareSearchableKeywords,
      },
      [SectionId.EXCHANGE_ANTISPAM]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTISPAM,
        guard: policyManager.isExchangeModuleAvailable,
        searchableKeywords: getExchangeAntispamSearchableKeywords,
      },
      [SectionId.EXCHANGE_CONTENT_CONTROL]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_EXCHANGE_CONTENT_CONTROL,
        guard: policyManager.isExchangeModuleAvailable,
        searchableKeywords: getExchangeContentControlSearchableKeywords,
      },
    },
    [ModuleId.ENCRYPTION]: {
      [SectionId.GENERAL]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_ENCRYPTION_GENERAL,
        guard: policyManager.isEncryptionModuleAvailable,
        searchableKeywords: getEncryptionSearchKeywords,
      },
    },
    [ModuleId.EDR_SENSOR]: {
      [SectionId.GENERAL]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_EDR_SENSOR_GENERAL,
        guard: policyManager.isEdrSensorModuleAvailable,
        searchableKeywords: getEdrSensorGeneralSearchableKeywords,
      },
    },
    [ModuleId.STORAGE_PROTECTION]: {
      [SectionId.STORAGE_PROTECTION_ICAP]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_STORAGE_PROTECTION_ICAP,
        guard: policyManager.isStorageProtectionModuleAvailable,
        searchableKeywords: getStorageIcapSearchableKeywords,
      },
      [SectionId.EXCLUSIONS]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_STORAGE_PROTECTION_EXCLUSIONS,
        guard: policyManager.isStorageProtectionModuleAvailable,
        searchableKeywords: getStorageExclusionsSearchableKeywords,
      },
    },
    [ModuleId.BLOCKLIST_RULES]: {
      [SectionId.NONE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_BLOCKLIST_RULES_GENERAL,
        guard: policyManager.isBlocklistModuleAvailable,
        searchableKeywords: getBlocklistRulesSearchableKeywords,
      },
    },
    [ModuleId.INDICATORS_OF_RISK]: {
      [SectionId.NONE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_INDICATORS_OF_RISK_GENERAL,
        guard: policyManager.isIndicatorsOfRiskModuleAvailable,
        searchableKeywords: getIndicatorsOfRiskSearchableKeywords,
      },
    },
    [ModuleId.LIVE_SEARCH]: {
      [SectionId.NONE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_LIVE_SEARCH,
        guard: policyManager.isLiveSearchModuleAvailable,
        searchableKeywords: getLiveSearchSearchableKeywords,
      },
    },
    [ModuleId.NSX]: {
      [SectionId.NONE]: {
        uiElementName: WEB_COMPONENT_POLICY_PANEL_NSX,
        guard: policyManager.isNsxModuleAvailable,
        searchableKeywords: getNsxSearchableKeywords,
      },
    },
  };
}
